import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const form = this.element.closest('form');
    form.addEventListener('turbo:submit-start', () => {
      form.classList.add('disabled');
      form.disabled = true;
      // Disable all the inputs
      form.querySelectorAll('input, select, textarea').forEach((input) => {
        input.setAttribute('disabled', 'disabled');
      });
    });
  }
}
